import { mergeStyleSets } from '@uifabric/merge-styles';

export default mergeStyleSets({
  noStatementsText: {
    fontWeight: 400,
  },
});
